export function LoadingState({ label = 'Caricamento…' }: { label?: string }) {
  return (
    <div className="loading-state" role="status">
      <span className="loading-state__mark">24</span>
      <span>{label}</span>
    </div>
  )
}
